<template>
    <div class="z-tooltip" :class="classObject" ref="tooltip">
        <template v-if="!slots.trigger">
            <slot />
            <z-icon
                v-show="showIcon"
                width="16"
                height="16"
                :name="iconName"
                dir="up"
                class="z-tooltip__icon"
            />
        </template>

        <div :class="{'z-tooltip--is-opened': isOpened}" v-else>
            <slot name="trigger"></slot>
        </div>
    </div>

    <div
        ref="contentRef"
        v-if="!!slots.content"
        class="z-tooltip__content"
        :class="{'z-tooltip__content--with-close': closeBtnIsVisible}"
    >
        <button v-show="closeBtnIsVisible" @click="closeTooltip" class="z-tooltip__close">
            <z-icon
                name="tools/close"
                dir="down"
                class="z-tooltip__close--icon"
            />
        </button>
        <slot name="content"></slot>
    </div>
</template>

<script setup>
// import { useSlots } from 'vue'
import { computed, ref, useSlots, onMounted } from 'vue'
import tippy from 'tippy.js'

const props = defineProps({
    theme: {
        type: String,
        default: 'light',
        validator: (prop) => ['light', 'dark'].includes(prop)
    },
    showArrow: {
        type: Boolean,
        default: true
    },
    showIcon: {
        type: Boolean,
        default: true
    },
    showCloseBtn: {
        type: Boolean,
        default: false
    },
    trigger: {
        type: String,
        default: 'mouseenter',
        validator: (prop) => ['mouseenter', 'click'].includes(prop)
    },
    iconName: {
        type: String,
        default: 'tools/tooltip-hover'
    },
    placement: {
        type: String,
        default: 'bottom',
        validator: (prop) => [
            'top',
            'top-start',
            'top-end',
            'right',
            'right-start',
            'right-end',
            'bottom',
            'bottom-start',
            'bottom-end',
            'left',
            'left-start',
            'left-end',
            'auto',
            'auto-start',
            'auto-end',
        ].includes(prop)
    },
    options: {
        type: Object
    }
})

const isOpened = ref(false)
const tooltip = ref(null)
const contentRef = ref(null)

const slots = useSlots()

const closeBtnIsVisible = computed(() => {
    return props.trigger === 'click' ? true : props.showCloseBtn
})

const classObject = computed(() => {
    return [
        { 'z-tooltip--click': props.trigger === 'click' },
        {'z-tooltip--is-opened': isOpened.value}
    ]
})

const closeTooltip = () => {
    tooltip.value._tippy.hide()
}

const initTippy = () => {
    tippy(tooltip.value, {
        content: contentRef.value,
        appendTo: document.body,
        placement: props.placement,
        arrow: props.showArrow,
        trigger: props.trigger,
        allowHTML: true,
        interactive: closeBtnIsVisible.value,
        theme: props.theme,
        hideOnClick: !closeBtnIsVisible.value,
        ...props.options,
        onShow () {
            isOpened.value = true
        },
        onHide () {
            isOpened.value = false
        }
    })
}

onMounted(() => {
    initTippy()
})

defineExpose({
    props
})
</script>

<style lang="scss" src="./index.scss"></style>
